export default __webpack_public_path__ + "static/media/earnMoreBtn.c5dbe374.png";